import { User } from './user';
import { apiHost, deleteOne, queryOne } from '../shared/technical/rest/restApi';
import { AxiosInstance } from 'axios';

export function getAccount(customAxios: AxiosInstance): Promise<User> {
  return queryOne<User>(customAxios, 'account');
}

export function markAccountForDeletion(customAxios: AxiosInstance): Promise<void> {
  return deleteOne<User>(customAxios, 'account');
}

/**
 * Downloads all data of the account as ZIP archive with CSV files and lets the browser save it.
 */
export function downloadAccountData(customAxios: AxiosInstance): Promise<void> {
  return customAxios.get<Blob>(apiHost + '/account/export', {responseType: 'blob'})
    .then(response => {
      const disposition: string = response.headers['content-disposition'] || '';
      const match = /filename="?([^";]+)"?/.exec(disposition);
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = match ? match[1] : 'meinemessungen-export.zip';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
}

export function deleteAccount(customAxios: AxiosInstance, token: string): Promise<void> {
  return deleteOne<User>(customAxios, 'account/' + token);
}
